import React, { Component } from 'react';
import { QuestionCategory } from "../../../../../wpconfig";
import * as func from "../../../../../utils/functions";

class MPPhoto extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: '',
			field: 'my_library/photo'
		}
	}

	closePopup = () => {
		this.props.closePopup('isShowEditPhoto')
	}

	onSave = (event) => {
		event.preventDefault()

		//빈파일이 아닌 경우 함수 진행
		if (this.file.files !== null) {
			//FormData 생성
			const p = new FormData();
			p.append('file', this.file.files[0]);
			func.updateFile(this.state.field, p).then((response) => {
				if (response.code === 'ok' || response.code === 'success') {
					let record = this.props.record;
					record.profile_pic = response.image;
					this.props.onUpdate(record);
					this.props.closePopup('isShowEditPhoto')
				} else {
					alert('전산팀에 문의해주세요.')
				}
			});
		}
	};

	render() {
		return (
			<div className="modal show" id="addPicture" tabIndex="-1">
				<div className="modal-dialog modal-sm modal-dialog-centered">
					<div className="modal-content pt-4 pr-4 pb-4 pl-4">
						<div className="modal-body">
							<div className="font-size-14 color-lightblack mb-px-10"><strong>사진 등록</strong></div>
							<div className="input-btn">
								<input type="file" className="form-control"
									accept="image/jpeg, image/jpg, image/png"
									ref={(ref) => this.file = ref}
								/>
								<button type="button" className="btn-control">
									<span className="icon icon-size-24 icon-search-gray" />
								</button>
							</div>
						</div>
						<div className="modal-footer mt-4">
							<button type="button" className="btn btn-outline-gray" onClick={this.closePopup}>
								<strong>취소</strong>
							</button>
							<button type="button" className="btn btn-darkblue" onClick={this.onSave}><strong>등록</strong></button>
						</div>
						<button type="button" className="btn-close" onClick={this.closePopup} />
					</div>
				</div>
			</div>
		)
	}
};

export default MPPhoto;
